import { AppBar, Box, Toolbar, TextField, Modal, useTheme, Table, TableCell, TableBody, Checkbox, Tooltip, TableContainer, TableHead, TableRow, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Typography, Divider, useScrollTrigger, Slide, CssBaseline, Container, Grid, Card, CardContent } from "@mui/material";
import  { useState, useEffect } from "react";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import Close from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';




import Searchicon from '@mui/icons-material/Search';
import AddWarehouseDetails from "../warehouse/AddNewLocationDetail";
import AllocateLocationForReel from "../warehouse/ViewAvailableSlots";
import CustomTableContainer from "../../Layout/CustomTableContainer";
import { callApi } from "../../pages/commonapicall/fetchdata";
import { API_ENDPOINTS } from "../../config/api/apiCall";
import { tokens } from "../../theme/theme";

// /Warehouse-view-available-slots




const WarehouseIndex = ({ handleBackWinderMachineEntry, reelID }) => {


    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Warehouse');
    const openFirst = Boolean(anchorElFirst);
    const [newLocation, setNewLocation] = useState(false);
    const [warehouseList, setWarehouseList] = useState(true);
    const [warehouseSlots, setWarehouseSlots] = useState(false);

    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);

    const [directStoreMode, setDirectStoreMode] = useState(false);

    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Vendors') {
            setSelectedStatus('All');
        }
        else if (option === 'Active Vendors') {
            setSelectedStatus('Active');
        }
        else if (option === 'Inactive Vendors') {
            setSelectedStatus('InActive');
        }


        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        handleMenuCloseSecond();
    };

    const handleShowNewVendor = () => {
        setEditPartyID(0);
        setWarehouseList(false);
        setWarehouseSlots(false);
        setNewLocation(true);
    }

    const handlecallback = () => {
        setEditPartyID(0);
        setWarehouseList(true);
        setWarehouseSlots(false);
        setNewLocation(false);
        const para = {
            p_companyid: 1,
        }

        callApi(API_ENDPOINTS.WAREHOUSE_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setPartyList(data);
                }
            })
            .catch(error => {
                alert(error.message);
            });
    }


    useEffect(() => {
        // alert('selected reel id :' + reelID);
        setDirectStoreMode(true);
    }, [reelID]);

    const handlecallbackAvailableSlot = () => {
        setEditPartyID(0);
        setWarehouseList(true);
        setWarehouseSlots(false);
        setNewLocation(false);
    }


    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [employeeDetails, setemployeeDetails] = useState([]);

    useEffect(() => {
        if (!isDataLoaded) {

            const para = {
                p_companyid: 1,
            }


            callApi(API_ENDPOINTS.Example_Employee_form, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setemployeeDetails(data);

                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);


    const [partyList, setPartyList] = useState([]);

    useEffect(() => {
        if (!isDataLoaded) {

            const para = {
                p_companyid: 1,
            }

            callApi(API_ENDPOINTS.WAREHOUSE_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setPartyList(data);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);



    const [open, setOpen] = useState(false);
    const [filters, setFilters] = useState({
        name: '',
        companyname: '',
        email: '',
        workphone: '',
        status: '',
        payales: '',
    });

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = partyList.map((row) => row.id);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };

    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);

        if (newSelectedRows.length > 0) {
            setShowNewToolbar(true); // Show new toolbar when rows are selected
            setShowFirstToolbar(false);
        } else {
            setShowNewToolbar(false); // Hide new toolbar when no rows are selected
            setShowFirstToolbar(true);
        }
    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;


    const [selectedRows, setSelectedRows] = useState([]);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const [showNewToolbar, setShowNewToolbar] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('All');

    const filteredData = partyList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const [editPartyID, setEditPartyID] = useState(0)
    const [storageID, setStorageID] = useState(0)
    const handleCallEdit = (value, storage_code) => {
        setEditPartyID(value);
        setStorageID(storage_code);
        setWarehouseList(false);
        setNewLocation(false);
        setWarehouseSlots(true);

    };

    return (
        <Box>
            <CssBaseline />

            {warehouseList && (<>
                <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                    <Toolbar>
                        {/* First Menu */}
                        <Button
                            color="secondary"
                            onClick={handleMenuClickFirst}
                            endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                            sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                        >
                            {selectedOptionFirst}
                        </Button>
                        <Menu
                            anchorEl={anchorElFirst}
                            open={openFirst}
                            onClose={handleMenuCloseFirst}

                        >
                            <MenuItem onClick={() => handleMenuItemClickFirst('All Warehouse')}>All Warehouse</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('Purchase Products')}>Purchase Products</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('Sales Products')}>Sales Products</MenuItem>
                        </Menu>

                        {/* Adding margin-left: auto to push the button to the right */}
                        <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Location</Button>

                        {/* Second Menu */}
                        <IconButton
                            size="small"
                            // edge="start"
                            // color="inherit"
                            aria-label="menu"
                            sx={{ ml: 2 }}
                            onClick={handleMenuClickSecond}
                        >
                            <MoreVertIcon sx={{fontSize: "18px"}} />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElSecond}
                            open={openSecond}
                            onClose={handleMenuCloseSecond}
                        >
                            <MenuItem onClick={() => handleMenuItemClickSecond('Import Vendors')}>
                                <ListItemIcon>
                                    <ImportExportIcon />
                                </ListItemIcon>
                                <ListItemText primary="Import Vendors" />
                            </MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Vendors')}>
                                <ListItemIcon>
                                    <FileDownloadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Vendors" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                <ListItemIcon>
                                    <ViewColumnIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Current View" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                <ListItemIcon>
                                    <ListAltIcon />
                                </ListItemIcon>
                                <ListItemText primary="Preference " />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                <ListItemIcon>
                                    <RefreshIcon />
                                </ListItemIcon>
                                <ListItemText primary="Refresh List" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>
                                {/* <ListItemIcon>
                                    <FormatAlignJustifyIcon />
                                </ListItemIcon>
                                <ListItemText primary="Reset Column Width" /> */}
                                <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                    Reset Columns Width
                                </Button>
                            </MenuItem>
                        </Menu>

                        <IconButton
                            size="small"
                            // edge="start"
                            // color="inherit"
                            aria-label="menu"
                            sx={{ mr: 1, ml: 1 }}
                            onClick={handleMenuClickSecond}
                        >
                            <HelpIcon sx={{ fontSize: "18px" }} />
                        </IconButton>

                        <div>
                            <IconButton onClick={handleBackWinderMachineEntry} >
                                <Close fontSize="inherit" style={{ fontSize: "18px",color: "#2196F3" }} />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>

                {/* <Box
                    sx={{
                        padding: "5px",
                        borderRadius: "10px",
                        maxHeight: {
                            xs: '72vh', // Extra small devices (phones)
                            sm: '72vh', // Small devices (tablets)
                            md: '74vh', // Medium devices (small laptops)
                            lg: '74vh', // Large devices (desktops)
                            xl: '82vh', // Extra large devices (large desktops)
                        },
                        overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                        '&::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: colors.primary[400],
                            borderRadius: '10px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: colors.blueAccent[600],
                            borderRadius: '10px',
                            '&:hover': {
                                background: colors.blueAccent[800],
                            },
                        },
                        '&::-webkit-scrollbar-corner': {
                            background: colors.primary[700],
                        }
                    }}>
                    <Grid container  >
                        <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >

                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"> */}

                {/* Warehouse List */}
                {/* <Box
                    gridColumn="span 9"
                    gridRow={"span 2"}
                    alignItems="center"
                    justifyContent="center"
                    padding={1}
                    sx={{
                        "& .MuiTable-root": {
                            border: "none",
                            size: "small",
                        },
                        "& .MuiTableCell-root": {
                            borderBottom: "none",
                            // fontWeight: "bold",
                            border: "1px solid ",
                            borderColor: `${colors.primary[400]} !important`,
                        },
                        "& .name-column--cell": {
                            color: colors.greenAccent[300],
                        },
                        "& .MuiTableHead-root": {
                            // backgroundColor: colors.blueAccent[700],
                            borderBottom: "none",


                        },
                        "& .MuiTableBody-root": {
                            overflowY: "auto",
                        },
                        "& .MuiCheckbox-root": {
                            color: `${colors.blueAccent[200]} !important`,
                            size: "small",
                        },
                        "& .MuiTableFooter-root": {
                            borderTop: "none",
                            backgroundColor: colors.blueAccent[700],
                            height: "10px",
                        },
                        "& .MuiButton-text": {
                            color: `${colors.grey[100]} !important`,
                        },

                    }}> */}

                <CustomTableContainer colors={colors}>
                    <TableContainer >
                        <Table size="small">
                            <TableHead sx={{ height: 10 }}>
                                <TableRow>
                                    <TableCell>
                                        <Checkbox size="small" style={{ color: "secondary" }}
                                            indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                            checked={selectedRows.length === filteredData.length}
                                            onChange={handleSelectAllClick}
                                        />
                                    </TableCell>
                                    <TableCell>WAREHOUSE NAME</TableCell>
                                    <TableCell>WAREHOUSE LOCATION</TableCell>
                                    <TableCell>EMAIL</TableCell>
                                    <TableCell>WORK PHONE</TableCell>
                                    <TableCell>STATUS</TableCell>
                                    <TableCell>AVAILABLE STOCK</TableCell>
                                    <TableCell>
                                        <IconButton onClick={handleOpen}>
                                            <Searchicon style={{ fontSize: "16px" }} />
                                        </IconButton>
                                        <Modal
                                            open={open}
                                            onClose={handleClose}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                <TextField
                                                    label="NAME"
                                                    name="name"
                                                    value={filters.name}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Company Name"
                                                    name="companyName"
                                                    value={filters.companyname}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Email"
                                                    name="email"
                                                    value={filters.email}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="WorkPhone"
                                                    name="workPhone"
                                                    value={filters.workphone}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Status"
                                                    name="status"
                                                    value={filters.status}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Payables"
                                                    name="payables"
                                                    value={filters.payales}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />

                                                <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                    Apply Filter
                                                </Button>
                                            </Box>
                                        </Modal>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell>
                                            <Checkbox
                                                size="small"
                                                checked={isSelected(row.id)}
                                                onChange={(event) => handleRowCheckboxClick(event, row.id)}
                                            />
                                        </TableCell>
                                        {/* <TableCell>{row.name}</TableCell> */}
                                        <TableCell>
                                            <span
                                                style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                onClick={() => handleCallEdit(row.id, row.storage_mode)}
                                            >
                                                {row.description}
                                            </span>
                                        </TableCell>
                                        <TableCell>{row.location}</TableCell>
                                        <TableCell>{row.email}</TableCell>
                                        <TableCell>{row.work_phone}</TableCell>
                                        <TableCell>{row.status}</TableCell>
                                        {/* <TableCell>{row.payales}</TableCell> */}
                                        <TableCell>0</TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTableContainer>


                {/* </Box> */}
                {/* </Grid>
                        </Grid>

                    </Grid>

                </Box> */}

            </>)}
            {newLocation && (<>
                <AddWarehouseDetails handlecallback={handlecallback} />
            </>)}

            {warehouseSlots && (
                <>
                    <AllocateLocationForReel Warehouse_identification_number={editPartyID} handlecallbackAvailableSlot={handlecallbackAvailableSlot} reelID={reelID} storageID={storageID} />
                </>
            )}

        </Box>
    );
};
export default WarehouseIndex;